import React from 'react';

export default function LoginModal({
  open,
  onClose,
  onSubmit,
  form,
  onChange,
  error
}) {
  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <form
        onSubmit={onSubmit}
        style={{
          background: '#fff',
          padding: 32,
          borderRadius: 8,
          minWidth: 320,
          boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <h2 style={{ margin: 0 }}>Login</h2>
        {error && (
          <div style={{
            color: '#c00',
            background: '#ffeaea',
            border: '1px solid #c00',
            borderRadius: 4,
            padding: '8px',
            marginBottom: 8,
            fontSize: 14
          }}>{error}</div>
        )}
        <input
          type="text"
          name="username"
          placeholder="Benutzername"
          value={form.username}
          onChange={onChange}
          required
          style={{ padding: 8, fontSize: 16, borderRadius: 4, border: '1px solid #ccc' }}
        />
        <input
          type="password"
          name="password"
          placeholder="Passwort"
          value={form.password}
          onChange={onChange}
          required
          style={{ padding: 8, fontSize: 16, borderRadius: 4, border: '1px solid #ccc' }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: '#eee',
              color: '#333',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer'
            }}
          >
            Abbrechen
          </button>
          <button
            type="submit"
            style={{
              background: '#222',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer'
            }}
          >
            Login
          </button>
        </div>
      </form>
    </div>
  );
}